/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {MarketplaceCatalog} from './MarketplaceCatalog';

export interface Channel {
  id: number;
  header: string;
  enabled: boolean;
  marketplaceId: number;
  isSystem?: boolean;
  deleted?: boolean;
  selectedByDefault?: boolean;
  properties?: { [key: string]: string };
  categories?: MarketplaceCatalog[];
  catalogId: number;
  marketplaceCatalogId?: number;
}
